export default __webpack_public_path__ + "static/media/kitchen5-afterD-1440w.e73ca39f.avif";